/*
 * Busca com sugestoes.
 *
 * Comportamento vindo do Dawn: pede a /search/suggest o HTML ja
 * desenhado pela secao artisan-busca-resultados e troca so o pedaco de
 * resultados.
 *
 * Espera 250 ms depois da ultima tecla, para nao disparar um pedido por
 * letra digitada, e cancela o pedido anterior quando chega outro.
 */

(function () {
  const painel = document.getElementById('artisan-busca');
  if (!painel) return;

  const campo = painel.querySelector('[data-form-busca] input[name="q"]');
  const caixa = painel.querySelector('[data-resultados]');
  if (!campo || !caixa) return;

  let temporizador;
  let controle;

  async function buscar(termo) {
    if (controle) controle.abort();
    controle = new AbortController();

    const parametros = new URLSearchParams({
      q: termo,
      'resources[type]': 'product,collection,page',
      'resources[limit]': '6',
      section_id: 'artisan-busca-resultados',
    });

    try {
      const resposta = await fetch(
        `${window.Shopify.routes.root}search/suggest?${parametros}`,
        { signal: controle.signal }
      );
      const texto = await resposta.text();

      const miolo = new DOMParser()
        .parseFromString(texto, 'text/html')
        .querySelector('.shopify-section');

      caixa.innerHTML = miolo ? miolo.innerHTML : texto;
      campo.setAttribute('aria-expanded', 'true');
    } catch (erro) {
      if (erro.name !== 'AbortError') console.error('Busca falhou', erro);
    }
  }

  campo.addEventListener('input', () => {
    const termo = campo.value.trim();
    clearTimeout(temporizador);

    if (termo.length < 2) {
      caixa.innerHTML = '<p class="artisan-busca__vazio">Digite para ver sugestões.</p>';
      campo.setAttribute('aria-expanded', 'false');
      return;
    }

    temporizador = setTimeout(() => buscar(termo), 250);
  });
})();
